import ErrorFeedbackScreen from '../../components/shared/ErrorFeedbackScreen/ErrorFeedbackScreen';
import ErrorRoundImage from '../../assets/images/error-round.webp';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import useTranslation from '../../localization/i18n.context';
import { useEffect } from 'preact/hooks';
import NavigationUtils from '../../utils/navigation.utils';
import { TrackingEvent } from '../../sdk/tracking.event';

export default function CardActivationErrorPage() {
  const { t } = useTranslation();

  const closeWebview = () => {
    CloseWebviewEvent.finishWithError();
  };

  const restartFlow = () => {
    NavigationUtils.navigate(NavigationUtils.Routes.CARD_ACTIVATION, true);
  };
  useEffect(() => {
    TrackingEvent.trigger(
      TrackingEvent.Events.ACTIVATION_ERROR_SHOW,
      TrackingEvent.Sources.CAAS,
    );
  }, []);

  return (
    <ErrorFeedbackScreen
      onCloseClick={closeWebview}
      image={ErrorRoundImage}
      title={t('Something went wrong')}
      text={t('There was a problem activating your card')}
      subtitle={t(
        'Please check your internet connection and that you entered the right activation code and card numbers, then try again.',
      )}
      ctaAction={restartFlow}
      ctaText={t('Try Again')}
    />
  );
}
